
if (!global.test) {
    var auth = require('./auth-handler');
    var authHandler = auth.authHandler;
    var swal = require('bootstrap-sweetalert');
    swal.setDefaults({ animation: false });
    var router = require('./router').router;
};

var constants = require('./constants');
var awsConstants = constants.awsConstants;
var filekeyHelpers = require('./filekey-helpers');
var checksumHelpers = require('./checksum-helpers');
var computeHash = checksumHelpers.computeHash;
var generateChecksumErrorMessage = checksumHelpers.generateChecksumErrorMessage;

var uploadBuildFormModel = {
    init: function () {
        this.isProcessing = false;
    },
    getUsername: function () {
        return localStorage.getItem('username');
    }
};

var uploadBuildFormController = {
    init: function () {
        uploadBuildFormModel.init();
        uploadBuildFormView.init();
    },
    validateInputs: function (inputs) {
        var errorMessages = [];
        // if (!inputs.firmwareFileName || !inputs.firmwareFileName.length) {
        //     errorMessages.push('Name is required.');
        // }

        if (!inputs.buildFile || !inputs.buildFile.name) {
            errorMessages.push('Please select a valid Build file.');
        } else {
            const buildFileSuffix = '.bin';
            const buildFileKey = inputs.buildFile.name;
            if (!(buildFileKey.substring(buildFileKey.length - buildFileSuffix.length) === buildFileSuffix)) {
                errorMessages.push('Firmware must be a ".bin" file.');
            }
        }

        if (!inputs.buildFileChecksum || !inputs.buildFileChecksum.length) {
            errorMessages.push('Checksum is required for Firmware file.');
        }

        if (inputs.resourceFile1 && !inputs.resourceFile1Checksum) {
            errorMessages.push('Resource File 1 selected but no checksum entered');
        }

        if (!inputs.resourceFile1 && inputs.resourceFile1Checksum) {
            errorMessages.push('Resource File 1 checksum entered but no file selected');
        }
        return errorMessages;
    },
    validateChecksums: function (inputs) {
        // all files with respective checksums have been entered compare hash to checksum
        var fileHashPromises = [];
        var nameToFileArray = [
            {
                name: 'Firmware',
                file: inputs.buildFile,
                checksum: inputs.buildFileChecksum
            }
        ];

        if (inputs.resourceFile1) {
            nameToFileArray.push({
                name: 'Resource 1',
                file: inputs.resourceFile1,
                checksum: inputs.resourceFile1Checksum
            });
        }

        nameToFileArray.forEach(function (obj) {
            fileHashPromises.push(computeHash(obj.file));
        });

        return Promise.all(fileHashPromises).then(function (hashes) {
            var checksumErrorMessages = [];
            hashes.forEach(function (hash, index) {
                var fileObj = nameToFileArray[index];
                if (fileObj.checksum !== hash) {
                    checksumErrorMessages.push(generateChecksumErrorMessage(hash, fileObj.checksum, fileObj.name));
                }
            });
            console.log(checksumErrorMessages);
            return checksumErrorMessages;
        });
    },
    handleSubmit: function (inputs) {
        var self = this;
        var username = uploadBuildFormModel.getUsername();

        if (uploadBuildFormModel.isProcessing) return; // Avoid submits when in progress

        uploadBuildFormModel.isProcessing = true;
        var errorMessages = this.validateInputs(inputs);
        if (errorMessages.length) {
            uploadBuildFormModel.isProcessing = false;
            uploadBuildFormView.toggleSpinnerState('hide');
            swal('Validation Errors', errorMessages.join('\n'), 'error');
            return;
        }
        this.validateChecksums(inputs)
            .then(function (checksumErrorMessages) {
                if (checksumErrorMessages.length) {
                    uploadBuildFormModel.isProcessing = false;
                    uploadBuildFormView.toggleSpinnerState('hide');
                    swal('Validation Errors', checksumErrorMessages.join('\n'), 'error');
                    throw new Error('checksumsInconsistent');
                }

                inputs.buildFileName = inputs.buildFile.name.substring(0, inputs.buildFile.name.length - 4);
                var refreshTokenIfNeededPromise;
                if (window.session.isValid()) {
                    refreshTokenIfNeededPromise = Promise.resolve(null);
                } else {
                    refreshTokenIfNeededPromise = authHandler.init();
                }
                return refreshTokenIfNeededPromise;
            })
            .then(function () {
                return self.checkBuildFileExists(inputs.buildFileName, inputs.buildFileChecksum);
            })
            .then(function (result) {
                // File exists
                return true;
            })
            .catch(function (error) {
                if (error.code === 'NotFound') {
                    // Errors if no firmware exists with entered filename
                    return false;
                } else {
                    // Unexpected error or checksumsInconsistent error throw to final catch block
                    throw error;
                }
            })
            .then(function (buildExists) {
                if (buildExists) {
                    return new Promise(function (resolve, reject) {
                        swal({
                            title: 'Are you sure?',
                            text: 'Build already exists. Are you sure want to replace the file?',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonClass: 'btn-default',
                            confirmButtonText: 'Replace File',
                            closeOnConfirm: true
                        }, function (isConfirm) {
                            if (isConfirm) {
                                resolve();
                            } else {
                                uploadBuildFormModel.isProcessing = false;
                                uploadBuildFormView.toggleSpinnerState('hide');
                                reject('cancelled');
                            }
                        });
                    });
                }
            })
            .then(function () {
                return self.uploadFiles(inputs, username);
            })
            .then(function (result) {
                uploadBuildFormModel.isProcessing = false;
                uploadBuildFormView.toggleSpinnerState('hide');
                swal('Successful Upload', 'Firmware files successfully uploaded', 'success');
                router.navigate('/publish-build');
            })
            .catch(function (error) {
                uploadBuildFormModel.isProcessing = false;
                uploadBuildFormView.toggleSpinnerState('hide');                
                if (error.message === 'checksumsInconsistent' || error === 'cancelled' || error === 'authexpired') { return; }
                swal('Firmware Upload Error', error, 'error');
            });
    },
    checkBuildFileExists: function (buildName, checksum) {
        var key = filekeyHelpers.generateBuildFileKey(buildName, checksum);
        var params = {
            Bucket: awsConstants.buckets.std,
            Key: key
        };
        // will error in catch if firmware doesnt exist
        return window.s3.headObject(params).promise();
    },
    uploadFiles: function (inputs, username) {
        var params = [];
        var buildName = inputs.buildFile.name.substring(0, inputs.buildFile.name.length - 4);
        var buildFileKey = filekeyHelpers.generateBuildFileKey(buildName);
        var resource1FileKey;
        if (inputs.resourceFile1) {
            resource1FileKey = filekeyHelpers.generateResourceFile1Key(buildName);
        }
        params.push({
            Bucket: awsConstants.buckets.std,
            Key: buildFileKey,
            ContentType: inputs.buildFile.type,
            Body: inputs.buildFile,
            Metadata: {
                checksum: inputs.buildFileChecksum,
                username: username
            }
        });

        if (resource1FileKey) {
            params.push({
                Bucket: awsConstants.buckets.std,
                Key: resource1FileKey,
                ContentType: inputs.resourceFile1.type,
                Body: inputs.resourceFile1,
                Metadata: {
                    checksum: inputs.resourceFile1Checksum,
                    username: username
                }
            });
        }
        var fileUploadPromises = params.map(function (params) {
            return window.s3.putObject(params).promise();
        });
        return Promise.all(fileUploadPromises);
    }
};

var uploadBuildFormView = {
    init: function () {
        this.uploadBuildFormEl = document.querySelector('#upload-build-form');
        this.buildFileChecksumEl = document.querySelector('#build-file-checksum');
        this.buildFileEl = document.querySelector('#build-file');
        this.resourceFile1El = document.querySelector('#resource-file-1');
        this.resourceFile1ChecksumEl = document.querySelector('#resource-file-1-checksum');
        this.uploadButtonTextEl = document.querySelector('#upload-button-text');
        this.uploadButtonSpinnerEl = document.querySelector('#upload-button-spinner');
        this.initSubmitHandler();
        this.initDisplayedFileNameHandlers();
    },
    initDisplayedFileNameHandlers: function () {
        var self = this;
        // chrome prefixes filenames with Fakepath, below regex removes strips the prefix if its there
        this.buildFileEl.onchange = function (e) {
            self.updateSelectedFileName('build-file-div', this.value.replace(/^.*\\/, ''));
        };
        this.resourceFile1El.onchange = function (e) {
            self.updateSelectedFileName('resource-file-1-div', this.value.replace(/^.*\\/, ''));
        };
    },
    updateSelectedFileName: function (divId, fileName) {
        var selectedFileText = document.querySelector('#' + divId + ' .selected-file-text');
        selectedFileText.innerHTML = fileName;
        selectedFileText.style = 'margin-right:5px';
        document.querySelector('#' + divId + ' .select-file-button-text').innerHTML = 'Change File';
    },
    initSubmitHandler: function () {
        var self = this;
        // submit handler for upload firmware form
        this.uploadBuildFormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.toggleSpinnerState('show');

            var inputs = {
                buildFile: self.buildFileEl.files[0],
                buildFileChecksum: self.buildFileChecksumEl.value.replace(/ /g, '').trim(),
                resourceFile1: self.resourceFile1El.files[0],
                resourceFile1Checksum: self.resourceFile1ChecksumEl.value.replace(/ /g, '').trim()
            };
            uploadBuildFormController.handleSubmit(inputs);
        });

    },
    toggleSpinnerState: function (state) {
        if (state === 'show') {
            this.uploadButtonTextEl.innerHTML = 'Uploading';
            this.uploadButtonSpinnerEl.style = 'margin-right:5px;';
        } else {
            this.uploadButtonTextEl.innerHTML = 'Upload';
            this.uploadButtonSpinnerEl.style = 'display:none;';
        }
    }
};

module.exports = { uploadBuildFormController: uploadBuildFormController };
